import {
  ChevronDownIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/20/solid'
import ImageWithFallback from '@components/image/ImageWithFallback'

type TokenSelectProps = {
  imageUrl: string | undefined
  symbol: string | undefined
  showList: (show: boolean) => void
}

const SwapTokenSelect = ({ imageUrl, symbol, showList }: TokenSelectProps) => {
  return (
    <button
      onClick={() => showList(true)}
      className="flex h-9 items-center rounded-full bg-th-bkg-4 px-3 py-2 text-th-fgd-2 focus-visible:bg-th-bkg-3 md:hover:cursor-pointer md:hover:bg-th-bkg-3 md:hover:text-th-fgd-1"
    >
      <div className="mr-2.5 flex min-w-[24px] items-center">
        {imageUrl ? (
          <ImageWithFallback
            height={24}
            width={24}
            src={imageUrl}
            alt={`${symbol ?? ''} token logo`}
          />
        ) : (
          <QuestionMarkCircleIcon className="size-6 text-th-fgd-4" />
        )}
      </div>
      <div className="flex w-full items-center justify-between">
        {/* {loading && !symbol ? (
          <SheenLoader>
            <div className={`h-4 w-16 bg-th-bkg-2`} />
          </SheenLoader>
        ) : ( */}
        <span className="mr-2 text-base font-bold text-th-fgd-1">
          {symbol || '???'}
        </span>
        {/* )} */}
        <ChevronDownIcon className="size-6" />
      </div>
    </button>
  )
}

export default SwapTokenSelect
